import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-leave-list',
  templateUrl: './leave-list.component.html'
  
})
export class LeaveListComponent implements OnInit {


  actions:Array<String>=[];
  constructor() { }

  ngOnInit() {
  }

 getActions(){
   this.actions=['Select Action','Approve','Cancel','Reject'];
 }


}



// WEBPACK FOOTER //
// ./src/app/modules/leave/components/leave-list/leave-list.component.ts